import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    AllInterviewExperiences: [],
    AllDraftInterviewExperiences: [],
    InterviewExperience: null,
    InterviewExperienceChat: [],
};

const interviewExperiencesSlice = createSlice({
    name: "interviewExperiences",
    initialState,
    reducers: {
        setAllInterviewExperiences: (state, action) => {
            state.AllInterviewExperiences = action.payload;
        },
        setAllDraftInterviewExperiences: (state, action) => {
            state.AllDraftInterviewExperiences = action.payload;
        },
        setInterviewExperience: (state, action) => {
            state.InterviewExperience = action.payload;
        },
        setInterviewExperienceChat: (state, action) => {
            state.InterviewExperienceChat = action.payload;
        },
    },
});

export const { setAllInterviewExperiences, setAllDraftInterviewExperiences, setInterviewExperience, setInterviewExperienceChat } = interviewExperiencesSlice.actions;

export default interviewExperiencesSlice.reducer;   